import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import TimeUtils from "@/utils/time-utils";
import Text = Phaser.GameObjects.Text;
import {ArtifactBasePanel} from "@/scenes.ui/artifact-base-panel";
import Container = Phaser.GameObjects.Container;
import ArtifactUtils from "@/utils/artifact-utils";
import {SquareButton} from "@/scenes.ui/square-button";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import {ForceUtils} from "@/utils/force-utils";
import {StringUtils} from "@/utils/string-utils";
import {CreatureUtils} from "@/utils/creature-utils";
import {ForceUpdateInfo} from "@/store/force/types";
import {ForceBasePanel} from "@/scenes.ui/force-base-panel";
import PlayerStore from "@/store/player";
import {Lang} from "@/store/player/types";
import {Link} from "@/scenes.ui/link";
import {WarriorClass} from "@/store/level/types";
import BBCodeText from "phaser3-rex-plugins/plugins/bbcodetext";
import TextStyle = BBCodeText.TextStyle;

export class ForceSpeedupPanel extends ForceBasePanel {

    private timeText: Text | undefined;
    private updatingTill: number | undefined;

    constructor(scene: Scene, canvas: HTMLCanvasElement, slotX: number, slotY: number,
                si: ForceUpdateInfo, speedupCallback: () => unknown, container: Container, showForceManualCallback: (wc: WarriorClass, rankLimit:number) => void) {
        super(scene, canvas, slotX, slotY, container);

        this.updatingTill = si.updatingTill;
        let fromZeroRank = si.currentLevel == 0;

        let blackZone = fromZeroRank? SpriteUtils.addSprite(this.scene, 0, -150+2 + 12, Keys.ATLAS_UI_FORCES, Keys.UI_FORCES_BLACK_ZONE, 0.95, 2.1) :
            SpriteUtils.addSprite(this.scene, 0, -150+2, Keys.ATLAS_UI_FORCES, Keys.UI_FORCES_BLACK_ZONE, 0.95, 1.7);
        let blackZone3 = SpriteUtils.addSprite(this.scene, 0, 82, Keys.ATLAS_UI_FORCES, Keys.UI_FORCES_BLACK_ZONE, 0.95, 3.2);
        blackZone3.setOrigin(0.5, 0);

        let forceName = PlayerStore.getPlayer().lang == Lang.RU ?
            StringUtils.capitalizeFirstLetter(Tr('force')) + ' ' + StringUtils.capitalizeFirstLetter(CreatureUtils.getClassNameGenetive(si.warriorClass)) :
            StringUtils.capitalizeFirstLetter(CreatureUtils.getClassNameGenetive(si.warriorClass)) + ' ' + StringUtils.capitalizeFirstLetter(Tr('force'));

        const title = TextUtils.addTextByFamily(this.scene, forceName, 0, -278, '#ffffff', 16,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);

        let updateTextString = fromZeroRank ? Tr('idet.izuchenie').toUpperCase() : Tr('idet.uluchshenie').toUpperCase();
        let updateText = TextUtils.addTextByFamily(scene, updateTextString,0, -223, fromZeroRank ? '#8fc465' : '#ffe8ba', 16, 'normal', 480, Fonts.MYRIADPRO_BOLD);

        let lightFrom = SpriteUtils.addSprite(this.scene, -87 - 4, -150 + 6, Keys.ATLAS_UI, Keys.UI_BADGE_LINER, 1.1);
        let lightTo = SpriteUtils.addSprite(this.scene,  fromZeroRank? 0 - 4 : 87 -4, -150 + 6, Keys.ATLAS_UI, Keys.UI_BADGE_LINER,  1.1);
        let itemFrom = SpriteUtils.addSprite(this.scene, -87, -150,
            CreatureUtils.getForceAtlasLarge(si.warriorClass), CreatureUtils.getLargeForceIcon(si.warriorClass, true), 0.8);
        let fromText = TextUtils.addTextAdvanced(scene, Tr('rang') + " " + si.currentLevel, -87, -87,
            '#e0e0e0', 13, 'normal', 150, 'center', 2, Fonts.ARIAL_MT);
        let itemArr = SpriteUtils.addSprite(this.scene, 0, -150, Keys.ATLAS_PROFILE, Keys.UI_ART_ARR);
        let itemTo = SpriteUtils.addSprite(this.scene, fromZeroRank? 0 : 87, -150,
            CreatureUtils.getForceAtlasLarge(si.warriorClass), CreatureUtils.getLargeForceIcon(si.warriorClass, true), 0.8);
        let toText = TextUtils.addTextAdvanced(scene, fromZeroRank ? forceName : Tr('rang') + " " + (si.nextLevel), fromZeroRank? 0 : 87, -87,
            '#85ff85', 13, 'normal', 250, 'center', 2, Fonts.ARIAL_MT);

        const fromRankBg = SpriteUtils.addImage(this.scene,
            -87 + 33, -150 +33, Keys.ATLAS_UI_FORCES, Keys.UI_FORCES_INDICATOR_BG, 1.1, 1.1).setOrigin(0.5, 0.5);
        let fromRankNumber = TextUtils.addTextByFamily(scene, si.currentLevel.toString(),
            -87 + 34, -150 + 35,'#daba6f', 15, 'bold', 450, Fonts.BENGALY_NORMAL).setOrigin(0.5, 0.5);

        const toRankBg = SpriteUtils.addImage(this.scene,
            (fromZeroRank? 0 : 87) + 33, -150 +33, Keys.ATLAS_UI_FORCES, Keys.UI_FORCES_INDICATOR_BG, 1.1, 1.1).setOrigin(0.5, 0.5);
        let toRankNumber = TextUtils.addTextByFamily(scene, (si.currentLevel + 1).toString(),
            (fromZeroRank? 0 : 87) + 34, -150 + 35,'#85ff85', 15, 'bold', 450, Fonts.BENGALY_NORMAL).setOrigin(0.5, 0.5);

        lightFrom.setVisible(!fromZeroRank);
        itemFrom.setVisible(!fromZeroRank);
        fromText.setVisible(false);
        toText.setVisible(fromZeroRank);
        fromRankBg.setVisible(!fromZeroRank);
        fromRankNumber.setVisible(!fromZeroRank);
        toRankBg.setVisible(!fromZeroRank);
        toRankNumber.setVisible(!fromZeroRank);

        let tagStyle : TextStyle= {
            fontFamily: Fonts.ARIAL_MT,
            fontSize: '13pt',
            align: 'center',
            wrap: {
                mode: 1,
                width: 300
            },
            color: '#d7d7d7'
        }

        let forceInfoLabel = new BBCodeText(scene, 0, fromZeroRank? 4 : -22,
            this.replaceTags(fromZeroRank? si.description : si.diffDescription), tagStyle).setScale(CU.S, CU.S);
        forceInfoLabel.setOrigin(0.5, 0.5);

        let link: Link = new Link(this.scene, -80*CU.S, 44, Tr('podrobnee.o.rangah'), () => {
            showForceManualCallback(si.warriorClass, si.maxLevel);
        }, '#c5a263', 14, 0, Fonts.ARIAL_MT);
        link.setVisible(!fromZeroRank);


        let timeLabel = TextUtils.addTextAdvanced(scene, Tr('ostalos.vremeni'), 0, 96,
            '#716f6a', 12, 'normal', 250, 'center', 2, Fonts.ARIAL_MT);

        const remainSec = Math.floor((si.updatingTill - TimeUtils.getServerTimeMs()) / 1000);

        this.timeText = TextUtils.addTextAdvanced(scene, TimeUtils.getDurationText(remainSec), 0, 119,
            '#ae9d26', 14, 'normal', 250, 'center', 2, Fonts.ARIAL_MT);

        let speedupButton = new SquareButton(this.scene, 0, 192, 0, Keys.UI_ART_GREEN_BUTTON,
            undefined, Keys.IC_100_MITHRIL, Tr('uskorit'), false);

        speedupButton.setScale(0.9, 0.9)

        speedupButton.setCallback(() => {
            if (this.isOnTop()) {
                speedupCallback();
            }
        });
        let speedupPriceText = TextUtils.addText(scene,
            String(si.speedupPrice), 0, 224, '#ffffff', 22, 'bold', 200);

        this.add([blackZone, blackZone3, title, this.timeText, speedupButton, speedupPriceText, updateText, lightFrom, lightTo, itemFrom,
            fromText, itemArr, itemTo, toText, timeLabel, forceInfoLabel, fromRankBg, toRankBg, fromRankNumber, toRankNumber, link]);
    }

    public refreshTimer(): void {
        if (this.active && this.timeText && this.updatingTill) {
            const remainSec = Math.floor((this.updatingTill - TimeUtils.getServerTimeMs()) / 1000);
            this.timeText.setText(remainSec > 0 ? TimeUtils.getDurationText(remainSec) : Tr('gotovo'));

            if(remainSec <= 0){
                this.active = false;
                this.close();
            }
        }
    }

    private replaceTags(str:string){
        str = str.replaceAll('[w]', '[color=#c5a263]');
        str = str.replaceAll('[g]', '[color=#85ff85]');
        str = str.replaceAll('[/w]', '[/color]');
        str = str.replaceAll('[/g]', '[/color]');
        return str;
    }
}
